import Vue from 'vue';
import Router from 'vue-router';

import Error404 from '@/components/404';
import LoginCallback from '@/components/LoginCallback';
import AdminLogin from '@/components/AdminLogin';
import dashboardRoutes from '@/router/routes.dashboard';
import airportsRoutes from '@/router/routes.airports';
import exploreRoutes from '@/router/routes.explore';
import AuthService from '@/services/AuthService';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
    },
    {
      path: '/*access_token=*',
      name: 'LoginCallback',
      component: LoginCallback,
      meta: {
        public: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: AdminLogin,
      meta: {
        public: true,
      },
    },
    { ...dashboardRoutes },
    { ...airportsRoutes },
    { ...exploreRoutes },
    {
      path: '*',
      name: '404',
      component: Error404,
      meta: {
        public: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    AuthService.isAuthenticated &&
    to.matched.some(record => record.path === '/login')
  ) {
    return next({
      path: '/',
    });
  }

  if (to.matched.some(record => record.meta.public)) {
    return next(true);
  }

  if (!AuthService.isAuthenticated) {
    return next({
      path: '/login',
    });
  }

  return next(true);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js